import gql from 'graphql-tag';
import FieldsEmployeeTransport from "graphql/fields/FieldsEmployeeTransport";
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'building_guid': 'String!',
	'transport_kind': 'String!',
	'license_plate': 'String'
}

export default gql(`
	mutation employee_transport( ${ HelperGraphql.createFields( fields ) } ) {
	    employee_transport( ${ HelperGraphql.createVariables( fields ) } ) {
	        ${FieldsEmployeeTransport}
	    }
	}
`);

